/**
 * SpecialOfferBanner Component
 *
 * Displays a clickable horizontal banner for special promotional offers.
 * Fetches active coupon packages from the API and only renders if any exist.
 */

import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { paymentService } from "../account/paymentService";

export default function SpecialOfferBanner() {
  const navigate = useNavigate();
  const { t } = useTranslation("account");
  const [activeCoupon, setActiveCoupon] = useState(null);

  useEffect(() => {
    let mounted = true;
    const fetchCoupons = async () => {
      const result = await paymentService.getCouponPackages();
      if (!mounted) return;
      if (result.success && result.data?.packages?.length > 0) {
        setActiveCoupon(result.data.packages[0]);
      }
    };
    fetchCoupons();
    return () => {
      mounted = false;
    };
  }, []);

  if (!activeCoupon) return null;

  const handleClick = () => {
    navigate("/topup");
  };

  return (
    <div
      className="bg-gradient-to-r from-orange-600 to-red-600 text-white py-3 px-4 cursor-pointer hover:from-orange-700 hover:to-red-700 transition-all duration-300"
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyPress={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          handleClick();
        }
      }}
    >
      <div className="max-w-7xl mx-auto text-center">
        <p className="text-sm md:text-base font-medium">
          {t("specialOfferBanner", {
            couponCode: activeCoupon.coupon_code,
            defaultValue: `🎉 Special Offer: {{couponCode}} – Get exclusive discounts on credit packages! Click here to top up →`,
          })}
        </p>
      </div>
    </div>
  );
}
